import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const StudyToolkit = () => {
  const navigate = useNavigate();

  const tools = [
    { icon: '⏱️', label: 'Study Timer', bg: 'bg-indigo-100', color: 'text-indigo-700', route: '/Studytimer' },
    { icon: '🎴', label: 'Flashcards', bg: 'bg-yellow-100', color: 'text-yellow-700', route: '/flash' },
    { icon: '📝', label: 'Notes', bg: 'bg-emerald-100', color: 'text-emerald-700', route: '/notes' },
    { icon: '🗣️', label: 'Ask Buddy', bg: 'bg-red-100', color: 'text-red-700', route: '/ask' },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-emerald-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center">
        <ClockIcon className="w-8 h-8 mr-3 text-emerald-600" />
        Study Toolkit
      </h2>
      <div className="grid grid-cols-2 gap-4">
        {tools.map((tool, index) => (
          <button
            key={index}
            onClick={() => navigate(tool.route)}
            className={`flex flex-col items-center justify-center p-4 ${tool.bg} ${tool.color} rounded-xl shadow-sm hover:shadow-lg transition-all duration-200 hover:scale-105`}
          >
            <span className="text-3xl mb-1">{tool.icon}</span>
            <span className="font-semibold text-sm md:text-base">{tool.label}</span>
          </button>
        ))}
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">My Study Buddy Says...</h3>
      <div className="bg-gray-100 p-4 rounded-xl shadow-sm flex items-start space-x-3 border-l-4 border-purple-500">
        <div className="w-10 h-10 bg-purple-200 rounded-full flex items-center justify-center text-2xl">🦉</div>
        <p className="text-gray-700 italic">
          "Remember, every small step forward is a big leap in your learning journey! Keep shining!"
        </p>
      </div>
    </div>
  );
};

export default StudyToolkit;
